class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    if (this.mainDetailsToggle.open) {
      requestAnimationFrame(setMegaMenuContentMaxHeights);
    }
  }
}

customElements.define('header-menu', HeaderMenu);

function setMegaMenuContentMaxHeights() {
  if (!document.querySelector('.mega-menu')) return;

  const contents = document.querySelectorAll('.mega-menu .mega-menu__content');
  if (!contents.length) return;

  const openContent = document.querySelector('.mega-menu[open] .mega-menu__content');
  const header = document.querySelector('.header-wrapper');
  let contentTop;

  if (openContent) {
    contentTop = openContent.getBoundingClientRect().top;
  } else if (header) {
    contentTop = header.getBoundingClientRect().bottom;
  } else {
    contentTop = contents[0].getBoundingClientRect().top;
  }

  const maxHeight = Math.max(0, Math.floor(window.innerHeight - contentTop));

  contents.forEach((content) => {
    content.style.maxHeight = `${maxHeight}px`;
  });
}

let megaMenuMaxHeightTimer;

function scheduleMegaMenuContentMaxHeights() {
  requestAnimationFrame(setMegaMenuContentMaxHeights);
}

window.addEventListener('resize', () => {
  clearTimeout(megaMenuMaxHeightTimer);
  megaMenuMaxHeightTimer = setTimeout(scheduleMegaMenuContentMaxHeights, 100);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleMegaMenuContentMaxHeights);
} else {
  scheduleMegaMenuContentMaxHeights();
}

window.addEventListener('load', scheduleMegaMenuContentMaxHeights);
document.addEventListener('shopify:section:load', scheduleMegaMenuContentMaxHeights);
